const CLUB_PATH_REGEX = /\/(.*?)\/([^\n/]*)\/?/g;

export const resolveBaseUrlAndClubName = () => {
    const match = CLUB_PATH_REGEX.exec(window.location.pathname) ?? [];
    const prefix = match?.[1];
    const clubName = match?.[2];
    const isClub = !!(prefix === 'club' && clubName);
    const base = process.env.BASE_URL + (isClub ? `club/${clubName}` : '');

    return { base, clubName };
};
